<template>
  <div class="container">
    <div class="flex-col mar-top-50">
      <div class="mar-bottom-50">
        <PageHeading
          :title="`${
            dataSourceDetails ? dataSourceDetails.datasource_name : 'Datasource'
          } Details`"
          :description="'Details of the Datasource'"
          :tooltip="''"
        />
      </div>
    </div>
    <div class="data-source-details">
      <div class="flex-col bg-secondary br-5 smooth-shadow">
        <div class="header flex-row-align-center pad-5">
          <i
            class="material-icons icon-button"
            @click="$router.push('/organisation?tab=datasources')"
            >arrow_back</i
          >
          <h3 v-if="isDataAvailable" class="pad-left-15">DataSource Details</h3>
          <div v-else class="title-placeholder mar-left-15"></div>
          <div class="flex-expand"></div>
          <!-- <button class="button inverted mar-right-10 flex-center fs-small">
          <i class="material-icons md-18 mar-right-10">launch</i> LOGS
          </button>-->
        </div>
        <div v-if="isDataAvailable" class="contents">
          <div class="schema-area">
            <h3 class="pad-10">Schema</h3>
            <div class="schema-search">
              <input
                type="text"
                placeholder="Search Columns"
                v-model="searchTerm"
              />
              <icon>search</icon>
            </div>
            <ul class="schema-list">
              <li v-for="column in getColumns()" :key="column.id">
                <p class="flex-center">
                  <b>{{ column.name }}</b>
                  <span v-if="column.primary_key" class="pk-chit"
                    >Primary Key</span
                  >
                  <span class="pk-chit inverted">{{ column.info_type }}</span>
                  <span v-if="column.is_measure" class="pk-chit inverted"
                    >Measure</span
                  >
                  <span v-if="column.is_dimension" class="pk-chit dimension"
                    >Dimension</span
                  >
                </p>
                <p class="caption">{{ column.data_type }}</p>
              </li>
            </ul>
          </div>
          <div class="details-area">
            <h3 class="pad-10">Details</h3>
            <label class="fc-primary pad-left-10">Data Source Name</label>
            <p>{{ dataSourceDetails.datasource_name || `No id available` }}</p>
            <label class="fc-primary pad-left-10">Data Source ID</label>
            <p>{{ dataSourceId || `No id available` }}</p>
            <label class="fc-primary pad-left-10">Data Source Type</label>
            <p>
              {{ dataSourceDetails.is_ping ? "Ping Data" : "Non Ping Data" }}
            </p>
            <!-- <label class="fc-primary pad-left-10">Last sync</label>
            <p>25 mins ago</p>-->
          </div>
        </div>
        <div v-else class="pad-30">
          <LoadingBar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      dataSourceDetails: null,
      isDataAvailable: false,
      dataSourceId: "",
      searchTerm: "",
    };
  },
  computed: {
    ...mapGetters("Datasources", ["getDataSourceDetails"]),
  },
  methods: {
    ...mapActions("Datasources", ["fetchDataSourceDetails"]),
    /**
     * Emulate back press in browser
     */
    goBack() {
      this.$router.go(-1);
    },
    getColumns() {
      if (this.dataSourceDetails && this.dataSourceDetails.columns) {
        const regex = new RegExp(this.searchTerm, "i");
        return this.dataSourceDetails.columns
          .map((column) => ({
            id: column.col_name,
            ...column,
          }))
          .filter((item) => regex.test(item.name))
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
      } else {
      }
    },
  },
  async activated() {
    // check for the datasource id
    this.dataSourceId = this.$route.params.id;

    if (this.dataSourceId) {
      try {
        this.dataSourceDetails = await this.fetchDataSourceDetails(
          this.dataSourceId
        );
        if (!this.dataSourceDetails) throw new Error("No data");
        this.isDataAvailable = true;
      } catch (error) {
        this.dataSourceDetails = null;
        this.isDataAvailable = true;
      }
    } else {
      this.dataSourceDetails = null;
      this.isDataAvailable = true;
    }
  },
};
</script>

<style lang="scss">
.data-source-details {
  margin-bottom: 100px;
  .header {
    border-bottom: 1px solid var(--border-color);
  }
  .custom-input {
    padding: 15px;
    border-radius: 5px;
    font-size: 1.2em;
    color: var(--font-color);

    &:focus {
      background: var(--border-color);
    }
  }

  .title-placeholder {
    background: var(--font-color-unselected);
    width: 200px;
    padding: 10px;
    border-radius: 10px;
  }

  .contents {
    display: flex;
    flex-direction: row;

    @include respond-below(sm) {
      flex-direction: column-reverse;
    }

    .schema-area {
      flex: 1;
      padding: 15px;
      border-right: 1px solid var(--border-color);
      display: flex;
      flex-direction: column;

      @include respond-below(sm) {
        border-right: 0;
      }

      .schema-search {
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;

        input {
          flex: 1;
          max-width: 100%;
          padding: 12px 12px 12px 40px;
          margin: 10px 0;
          position: relative;
        }

        i {
          position: absolute;
          left: 10px;
          opacity: 0.7;
        }
      }

      .schema-list {
        padding: 0;
        margin: 0;
        list-style-type: none;
        &:first-child {
          border-radius: 5px 5px 0 0;
        }

        &:last-child {
          border-radius: 0 0 5px 5px;
        }

        li {
          padding: 15px 15px;
          margin: 0;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid var(--color-secondary);
          background-color: var(--border-color);

          p {
            padding: 0;
            margin: 0;

            &.caption {
              color: var(--color-primary);
            }

            .pk-chit {
              font-size: 0.8em;
              background: var(--color-primary);
              color: var(--color-secondary);
              margin-left: 10px;
              border-radius: 2px;
              padding: 2px 10px;

              &.inverted {
                background: var(--color-secondary);
                color: var(--font-color);
              }

              &.dimension {
                background: var(--color-primary-light);
                color: var(--color-primary);
              }
            }
          }
        }
      }
    }

    .details-area {
      min-width: 400px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      @include respond-below(sm) {
        border-bottom: 1px solid var(--border-color);
      }

      p {
        margin: 0;
        padding: 5px 10px 10px 10px;
      }
    }
  }
}
</style>
